import type { CartUI } from '@libs/common-node';
import { PaymentMethodsType } from '@libs/core';

/** Sums the paid amount taken from applied gift cards. The gift card balance is ignored. */
function getAppliedGiftCardPaymentTotal(cart: CartUI): number {
    return (
        cart.paymentMethods?.reduce((total, paymentMethod) => {
            if (paymentMethod.method !== PaymentMethodsType.GIFTCARD || paymentMethod.amount == null) {
                return total;
            }

            return total + Math.abs(paymentMethod.amount);
        }, 0) ?? 0
    );
}

/**
 * Qualifying cart subtotal for the free-shipping minimum.
 *
 * Derived from the estimated total after discounts, promotions, and Treats rewards.
 * Excludes tax, shipping, charity donations, and delivery tip. Applied gift card
 * amounts are added in the calculation because totalAmount already reflects the deduction.
 */
export function calculateQualifyingSubtotal(cart: CartUI): number {
    const totalAmount = cart.summary?.totalAmount ?? 0;
    const taxTotal = cart.summary?.taxAmounts?.total ?? 0;
    const shippingCost = cart.summary?.shippingCost ?? 0;
    const donationAmount = cart.summary?.donationAmount ?? 0;
    const roundUpDonationAmount = cart.summary?.roundUpDonationAmount ?? 0;
    const deliveryTip = cart.summary?.deliveryTip ?? 0;
    const appliedGiftCardPaymentTotal = getAppliedGiftCardPaymentTotal(cart);

    return Math.max(
        0,
        totalAmount -
            taxTotal -
            shippingCost -
            donationAmount -
            roundUpDonationAmount -
            deliveryTip +
            appliedGiftCardPaymentTotal
    );
}
